export enum ProcedureMethodSettingsDropdownOptions {
  EDIT = 'Edit details',
  DUPLICATE = 'Duplicate',
  DELETE = 'Delete',
}
